var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "schedule-row",
      class: [_vm.schedule.eventType],
      on: { click: _vm.onClick },
    },
    [
      _c("img", {
        staticClass: "schedule-row__flag",
        attrs: {
          src: require(`@/assets/images/flags/${_vm.schedule.country}.webp`),
          alt: "flag",
        },
      }),
      _c("div", { staticClass: "schedule-row__body" }, [
        _c("div", { staticClass: "schedule-row__top" }, [
          _c("span", { staticClass: "schedule-row__event-name" }, [
            _vm._v(_vm._s(_vm.schedule.eventName)),
          ]),
          _vm.schedule.matchDay
            ? _c("span", { staticClass: "schedule-row__match-day" }, [
                _vm._v(_vm._s(_vm.schedule.matchDay.toUpperCase())),
              ])
            : _vm._e(),
          _vm.schedule.eventType === "current"
            ? _c("span", { staticClass: "schedule-row__live" }, [
                _vm._v(_vm._s(_vm.$t("LIVE"))),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "schedule-row__meta" }, [
          _c("span", { staticClass: "schedule-row__date-time" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.renderDateTime(
                    _vm.schedule.startFightDateTime
                      ? _vm.schedule.startFightDateTime
                      : _vm.schedule.matchStartDateTime,
                    "date"
                  )
                ) +
                " " +
                _vm._s(
                  _vm.renderDateTime(
                    _vm.schedule.startFightDateTime
                      ? _vm.schedule.startFightDateTime
                      : _vm.schedule.matchStartDateTime,
                    "time"
                  )
                ) +
                " "
            ),
          ]),
          _vm.schedule.eventDescription
            ? _c("span", { staticClass: "schedule-row__desc" }, [
                _vm._v(_vm._s(_vm.schedule.eventDescription)),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "schedule-row__fights" }, [
        _c("img", {
          staticClass: "schedule-row__sword",
          attrs: {
            src:
              _vm.schedule.eventType === "current"
                ? _vm.swordFightBlack
                : _vm.swordFightWhite,
            alt: "",
          },
        }),
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.schedule.lastFightNumber
                ? _vm.schedule.lastFightNumber
                : _vm.schedule.expectedNumFights
            )
          ),
        ]),
      ]),
      _vm.showLinkIcon && _vm.schedule.imageUrl
        ? _c("div", { staticClass: "schedule-row__link" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/images/arrow-square-up-right.png"),
                alt: "",
              },
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }